import { useContext, useEffect, useState } from "react";
import { contatosResposta } from "../../interfaces/contatos";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { Button } from "../Styles";
import "./index.css"
import { listarCadastros } from "../../services/cadastros";
import { toast } from "react-toastify";
import { atualizarContato } from "../../services/atendimento";
import { criptografarDado, descriptografarDado } from "../../helpers";

interface propsContatos {
  contatos: contatosResposta[]
}

function ModalContatosSemCliente({ contatos }: propsContatos) {

  const { atualizarDados, modalExibir } = useContext(ModalEstadoContext)

  const [processando, setProcessando] = useState(false);
  const [contatoSelecionado, setContatoSelecionado] = useState<contatosResposta | null>(null);
  const [cadastros, setCadastros] = useState<any[]>([]);
  const [cadastroSelecionado, setCadastroSelecionado] = useState<string>("");

  const handleVincular = async () => {
    const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
    const permissoesAutorizadas = ['master', 'administrativo', 'atendimento_contato_vincular']
    const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

    if(!temPermissao) return toast.warn("Você não tem permissão para cadastrar um novo Contato.")
    if (!contatoSelecionado || !cadastroSelecionado) return;

    try {
      setProcessando(true);
      const idContatoCript = criptografarDado(contatoSelecionado.id.toString())
      const idCadastroCript = criptografarDado(cadastroSelecionado.toString())

      const payload = {
        idCadastro: idCadastroCript,
        nome: contatoSelecionado.nome,
        email: contatoSelecionado.email,
        telefone: contatoSelecionado.telefone,
      }

      const resposta = await atualizarContato(idContatoCript, payload);

      if (resposta.status === 200) {
        toast.success("Contato vinculado com Sucesso.")
        atualizarDados();
        modalExibir("");
      }
    } catch {
      toast.error("Erro ao vincular contato.")
    } finally {
      setProcessando(false);
    }
  }

  useEffect(() => {
    const buscarCadastros = async () => {
      try {
        setProcessando(true);

        const resposta = await listarCadastros({
          situacao: 'ativo',
          tipo: "cliente",
          termo: "",
          pagina: 1
        });

        if (resposta.data.length === 0) {
          setCadastros([]);
        } else {
          setCadastros(resposta.data);
        }
      } catch {
        toast.error("Erro ao buscar cadastros");
      } finally {
        setProcessando(false);
      }
    }

    buscarCadastros()
  }, [])

  return (
    <div className="fundoModal">
      <section className='containerModalCentro'>
        <span className='novoContainerTitulo'>
          <h1>
            Contatos não vinculados
          </h1>
        </span>

        {!contatoSelecionado ? (
          <section className="container_contatos_nao_vinculado">
            <div className="container_contato">
              {contatos.map((contato) =>
                <div
                  key={contato.id}
                  className="contato_nao_vinculado"
                  onClick={() => setContatoSelecionado(contato)}
                >
                  <label>{contato.nome}</label>
                  <p>{contato.email}</p>
                  <p>{contato.telefone}</p>
                </div>
              )}
            </div>
          </section>
        ) : (
          <section>

            <section>
              <div className="container_contato">
                <div className="contato_nao_vinculado">
                  <label>{contatoSelecionado.nome}</label>
                  <p>{contatoSelecionado.email}</p>
                  <p>{contatoSelecionado.telefone}</p>
                </div>
              </div>
            </section>

            <div className="lista_cadastros">
              {cadastros.length > 0 && (
                <div className="select_container">
                  <label>Selecione um cadastro:</label>
                  <select
                    value={cadastroSelecionado}
                    onChange={(e) => setCadastroSelecionado(e.target.value)}
                  >
                    <option disabled value={""}>Selecione um Cadastro</option>
                    {cadastros.map((cadastro) => (
                      <option key={cadastro.id} value={cadastro.id}>
                        {cadastro.nomeFantasia}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </section>
        )}

        <span className="botoesContainer">
          <Button type='button' cor='cancelar' isLoading={processando} onClick={() => {
            setContatoSelecionado(null)
            modalExibir("");
          }}>
            Fechar
          </Button>
          {contatoSelecionado && (
            <Button
              type='button'
              cor='enviar'
              isLoading={processando}
              onClick={handleVincular}
            >
              Vincular
            </Button>
          )}
        </span>
      </section>
    </div >
  );
}

export default ModalContatosSemCliente;